import "../_namespaces.js";
import "../models/question.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Collections ??= {};

AssessmentViewer.Collections.Questions = class Questions extends Backbone.Collection {};
AssessmentViewer.Collections.Questions.prototype.model = AssessmentViewer.Models.Question;
